import React, { Component } from 'react'
import { observer } from 'mobx-react'
import store from '../../../store'
import { Auth } from '@common/Auth'
import { PRIVILEGE_STORE_ID, PRIVILEGE_STORE_SERVICE_ID } from '@constant'

class Property extends Component {
  onChange = () => {
    this.props.onChange(this.props.id)
  }

  render() {
    const { name, count, active } = this.props

    return (
      <div
        onClick={this.onChange}
        style={{
          margin: '0 13px',
          color: active === this.props.id ? '#448afc' : '#333',
          cursor: 'pointer',
          float: 'left',
          padding: '2px 0'
        }}
      >
        {name}({count})
      </div>
    )
  }
}

@Auth({ role: [PRIVILEGE_STORE_ID, PRIVILEGE_STORE_SERVICE_ID] })
@observer
export default class extends Component {
  render() {
    const { currentProperty, propertyList, changeProperty } = store

    return (
      <div
        style={{
          backgroundColor: '#f7f9fd',
          padding: '12.5px 0',
          fontSize: 14,
          display: 'flex',
          color: '#333',
          marginBottom: 20
        }}
        className="clearfix"
      >
        <div
          style={{
            marginLeft: 20,
            float: 'left',
            padding: '2px 0',
            flexShrink: 0
          }}
        >
          类目：
        </div>
        <div style={{ float: 'left' }} className="clearfix">
          {propertyList.map(item => (
            <Property
              key={item.id}
              {...item}
              onChange={changeProperty}
              active={currentProperty}
            />
          ))}
        </div>
      </div>
    )
  }
}
